jQuery(document).ready(function() {

  /* *************************************** START PROMO - ADD FREE GIFT BASED ON COLLECTION AMOUNT **************************** */   
// Kids Darth Vader Face Mask PID: 7133033824435 VID: 41454216249523
  

  
  function getPromotions() {
  	const promoDetails = {
      
      'Promo': [
        {
          'PromoName': 'VaderBOGO',
          'PromoStatus': false,
          'QualifierProductTag': 'Star Wars',
          'QualifierCartAmount': 6999,
          'popupCongratMessage': '<h1>Congratulations!</h1><p>Your order qualifies for a free gift.<p>',
          'popupMultiSelectMessage': '<h1>CHOOSE YOUR FREE GIFT!</h1><p>YOUR ORDER QUALIFIES FOR A FREE GIFT.',
          'Gifts': [
            { 'ItemName': 'Kids Darth Vader Face Mask','ItemPID': '7133033824435','ItemVID': '41454216249523','ItemImage': 'https://cdn.shopify.com/s/files/1/0565/3073/1187/products/C3441_1_500x.jpg' }
          ]
        },
        {
          'PromoName': 'NecaPromo',
          'PromoStatus': false,
          'QualifierProductTag': 'neca_promo',
          'QualifierCartAmount': 3000,
          'popupCongratMessage': '<h1 class="product-meta__title heading h1">Congratulations!</h1><p>Your order qualifies for a free gift.<p>',
          'popupMultiSelectMessage': '',
          'Gifts': [
            { 'ItemName': 'Adult Wonder Woman Wig','ItemPID': '6958579253427','ItemVID': '40794531659955','ItemImage': '' }
          ]
        }
      
      ]
    };
    return promoDetails;
    //alert(promoDetails.Promo[0].Gifts[0].ItemName);
  }
  
  BuildQualifierAmount();   
  function BuildQualifierAmount() {
    jQuery.getJSON('/cart.js', function(cart) {
      
      const promoDetails = getPromotions();
      const promos = promoDetails.Promo;
      
      for(var xPromo=0; xPromo < promos.length; xPromo++){
        
        const promoName = promos[xPromo].PromoName;
        const promoStatus = promos[xPromo].PromoStatus;
        const promoQualifierProductTag =  promos[xPromo].QualifierProductTag;
        const promoGifts = promos[xPromo].Gifts;
        
        localStorage.removeItem("cartQualAmount_" + promoName);localStorage.setItem("cartQualAmount_" + promoName, 0);
        localStorage.removeItem("cartQualExist_" + promoName);localStorage.setItem("cartQualExist_" + promoName, "false"); 
        if (promoStatus) {
          var items = cart.items;
          for(var xItems=0; xItems < items.length; xItems++){
            
            
            /* ********** IS ITEM ALREDY IN CART ********** */
            for(var xGifts=0; xGifts < promoGifts.length; xGifts++){  
              if (items[xItems].product_id == promoGifts[xGifts].ItemPID ) {
                localStorage.setItem("cartQualExist_" + promoName, "true");
              }
            }
            
            
            /* ********** CREATE CART TOTAL VALUE ********** */
            /*
            Not NEEDED AS NOT RESTRICTING IT TO A COLLECTION / PRODUCT TAG 
            */
            let lineItem = items[xItems].final_line_price;
            if (promoQualifierProductTag.length === 0) {
              localStorage.setItem("cartQualAmount_" + promoName, parseInt(cart.original_total_price));
            } else {
              jQuery.getJSON('/products/' + items[xItems].handle + '.js', function(product) {
                
                let tags = product.tags;
                for(var xTags=0; xTags < tags.length; xTags++){ 
                  
                  if (tags[xTags] == promoQualifierProductTag) {
                    let currentValue = localStorage.getItem("cartQualAmount_" + promoName);
                    localStorage.setItem("cartQualAmount_" + promoName, parseInt(currentValue) + parseInt(lineItem));
                  } 
                }
              });
            }
          }
        }
      }
    });	
    setTimeout(function() {
      isQualifier();
    }, 1000)
    
  }
  
  function UpdateQualifierAmount() {
    setTimeout(function() {
      BuildQualifierAmount();
    }, 1000)
  }
  
  function isQualifier() {
    const promoDetails = getPromotions();
    const promos = promoDetails.Promo;
    
    
    for(var xPromo=0; xPromo < promos.length; xPromo++){
      
      const promoName = promos[xPromo].PromoName;
      const promoStatus = promos[xPromo].PromoStatus;
      if (promoStatus) {
        const promoQualifierCartAmount = promos[xPromo].QualifierCartAmount;
        const promoQualifierProductTag =  promos[xPromo].QualifierProductTag;
        const promopopupCongratMessage =  promos[xPromo].popupCongratMessage;        
        const promopopupMultiSelectMessage =  promos[xPromo].popupMultiSelectMessage;        
        const promoGifts = promos[xPromo].Gifts;
        
        let currentAmount = localStorage.getItem("cartQualAmount_" + promoName);
        let itemAlreadyCart = localStorage.getItem("cartQualExist_" + promoName);
        let ignorePromo = localStorage.getItem("ignorepromo_" + promoName);
        
        if (currentAmount > promoQualifierCartAmount && itemAlreadyCart == "false"&& ignorePromo != "true") {
          
          //ADD ITEM TO CART
          if (promoGifts.length == 1) {
            //SINGLE ITEM. SIMPLY ADD TO CART
            addGiftToCart(promoGifts[0].ItemVID,promopopupCongratMessage); 
          } else {
            //MULTIPLE ITEMS. SHOW SELECTION POPUP
            let promoBody = '<div class="dr_promo_product_sel_wrapper">';
            for(var xGift=0; xGift < promoGifts.length; xGift++){
              
              promoBody += '<div class="dr_promo_product_sel_card" id="dr_promo_vid_' + promoGifts[xGift].ItemVID + '">';
              
              promoBody += '<div class="dr_promo_product_sel_img">';
              
              promoBody += '<img src="' + promoGifts[xGift].ItemImage + '" />'; 
              
              promoBody += '</div>'
              promoBody += '<div class="dr_promo_product_sel_title">'+ promoGifts[xGift].ItemName;
              promoBody += '</div>'
              promoBody += '<button class="dr_promo_product_button">ADD GIFT</button>';
              promoBody += '</div>'; 
            }
            promoBody += '</div>'; 
            dropenPopup(promopopupMultiSelectMessage,promoBody,'<button id="rubies_button_not_interested_' + promoName + '" class="dr_promo_not_interested">NO THANK YOU</button>');
            promoBody = '';
          } 
        } else if(currentAmount < promoQualifierCartAmount && itemAlreadyCart == "true") {
          // REMOVE ITEM FROM CART
          removeGiftFromCart(promoGifts[0].ItemVID);      
        }
      }
    }
  }
  
  function waitForFSPopup() {
    var fastSimonPopupLoaded = setInterval(function(){
      if ($('#serp-portal').length) {
        setTimeout(function(){
          var el = $('#serp-portal')[0].shadowRoot.querySelector('#serp-portal-content');
          
            if (el.innerHTML.length > 0) {
              clearInterval(fastSimonPopupLoaded);
              var buttons = el.querySelectorAll('button');
              console.log(el);
              var clicked = false;
              buttons.forEach(function(button){
                button.addEventListener('click', function() {
                  console.log('clicked', clicked);
                  // dispatch event to trigger update
                  if (clicked == false) {
                    clicked = true;
                    var event = new Event('fspopuploaded');
                    document.dispatchEvent(event);
                  }
                });
              })
            }
     
        },1000)
      }
    },1000);
  }
  
  waitForFSPopup();
  
  var fastSimonLoaded = setInterval(function(){
    if ($('#fast-simon-serp-app').length) {
      clearInterval(fastSimonLoaded);
      setTimeout(function(){
        var el = $('#fast-simon-serp-app')[0].shadowRoot.querySelector('#fs-serp-page');
        var buttons =  el.querySelectorAll('button,a');
        console.log(buttons, 'buttons');
        clearInterval(fastSimonLoaded);
        buttons.forEach(function(button){
          button.addEventListener('click', function() {
            waitForFSPopup();
            var event = new Event('fspopuploaded');
            document.dispatchEvent(event);
          });
        })
      },1000);
    }
  },10)
  
  document.addEventListener('fspopuploaded', function(e) { 
    setTimeout(function(){
      UpdateQualifierAmount();
    },1000)
  });
  
  jQuery( ".product-form__add-button" ).on( "click", UpdateQualifierAmount );
  jQuery( ".add-to-cart-button" ).on( "click", UpdateQualifierAmount );
  jQuery( ".add-to-cart-button" ).on('click', '#fast-simon-serp-app', function (){
    UpdateQualifierAmount();
  });
  
  
  /* Trigger to close out of stock modal */
  jQuery('.rubies-popup .rubies-btn-close').on("click",function(){
    jQuery('.rubies-popup-wrap').fadeOut(500);
  });
  
  jQuery('.rubies-popup-close ').on("click", '#rubies_button_close',function(){
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
    jQuery('.rubies-popup-wrap').fadeOut(500);
  });
  
  jQuery('.rubies-popup-close').on('click', '#rubies_button_cart', function (){
    location.href='/cart/';
  });
  
  
  jQuery('.rubies-popup-close').on('click', '.dr_promo_not_interested', function (){
    let promoName = jQuery(this).attr('id').replace("rubies_button_not_interested_", "");
    localStorage.setItem("ignorepromo_" + promoName, "true");
    jQuery('.rubies-popup-wrap').fadeOut(500);
  });
  
  
  jQuery('.rubies-popup-content').on('click', '.dr_promo_product_sel_card', function (){
    
    let addvID = jQuery(this).attr('id').replace("dr_promo_vid_", "");
    //jQuery('.rubies-popup-wrap').fadeOut(0);
    addGiftToCart(addvID,'<h1 class="product-meta__title heading h1">Congratulations!</h1><p>Your free gift has been added to your cart.<p>'); 
  });
  
  
  function addGiftToCart(variantId,promoMessage) {
    let formData = {
      'items': [{
        'id': variantId,
        'quantity': 1
      }]
    };
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
    
    dropenPopup(promoMessage,'','<button id="rubies_button_close" class="rubies_button rubies_button_close">Close</button><button id="rubies_button_cart" class="rubies_button rubies_button_option">Check your cart!</button>');
  }
  
  function removeGiftFromCart(variantId) {
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: "json",
      data: {
        id: parseFloat(variantId),
        quantity: 0,
      }
    });
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
  }
  
  function dropenPopup(promoMessage,promoBody,promoButtons) {
    
    jQuery(".rubies-popup-content").html(promoMessage + promoBody);
    if (promoButtons.length != 0) {jQuery(".rubies-popup-close").html(promoButtons);};
    
    jQuery(".rubies-popup-wrap").fadeIn(150);
    
  }
  
  // **************************************** END PROMO - ADD FREE GIFT BASED ON COLLECTION AMOUNT *****************************
});